













































































































































import Vue from 'vue'
import Player from './components/Player.vue'
import Introduction from './components/Introduction.vue'
import { AppStatus } from './types'

// eslint-disable-next-line @typescript-eslint/no-var-requires
Vue.use(require('vue-pusher'), {
  // eslint-disable-next-line @typescript-eslint/camelcase
  api_key: '66119fcbf5e86e125a6a',
  options: {
    cluster: 'eu',
    forceTLS: true,
  },
})

export default Vue.extend({
  name: 'App',
  components: {
    Player,
    Introduction,
  },
  data: function() {
    return {
      name: '',
      gameId: '',
      isGameMaster: false,
      status: AppStatus.showIntroduction,
      theAppStatus: AppStatus,
      useSalaryExpectations: false,
      useEducation: false,
      useInitiativeApplication: false,
    }
  },
  methods: {
    nameEntered() {
      if (this.name !== '') {
        this.status = AppStatus.enterGameId
        this.$nextTick(() => {
          ;(this.$refs.gameId as any).focus()
        })
      }
    },
    filterLetters() {
      this.name = this.name.replace(/[^a-zA-Z]+/g, '')
    },
    gameIdEntered() {
      if (this.gameId !== '') {
        this.status = AppStatus.startGame
      }
    },
    startGame() {
      this.status = AppStatus.gameStarted
      this.isGameMaster = true
    },
    gameStarted() {
      this.status = AppStatus.gameStarted
    },
  },
})
